export const MissionFeeEN = {
    "reasonMissionFee": {
        "column": {
            "name": "Title"
        },
        "title": "Mission Fee",
        "breadCrumb": "Manager missions fee",
        "pageHeader": {
            "reasonMissionFee": "Manager missions fee"
        }
    }
}
